import React from "react";
import Card from "src/componets/Card";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import { selectSettingById, SettingInterface } from "src/store/community/settingsSlice";
import { AppInterface } from "src/store/community/appsSlice";
import { updateSetting } from "src/actions/community/settingsActions";
import RemoveAds from "../../Settings/_partials/_RemoveAds";
import Rewards from "../../Settings/_partials/_Rewards";
import Account from "../../Settings/_partials/_Account";
import Community from "../../Settings/_partials/_Community";
import Content from "../../Settings/_partials/_Content";

import { message } from "antd";
import Purchase from "../../Settings/_partials/_Purchase";

const _Settings = ({ app } : { app: AppInterface | undefined }) => {
  const dispatch = useAppDispatch();
  const setting = useAppSelector(state => app?.setting ? selectSettingById(state, app?.setting) : undefined);
  const params: any = { ...setting?.data };

  if (!app) {
    return null;
  }

  function onFinish(data: any) {
    handleSave(data).catch(console.error);
  }

  async function handleSave(data: SettingInterface['data']) {
    const id = setting?.id;
    const newData: any = { data: { ...data } };

    if (!id) {
      return;
    }

    const resultAction = await dispatch(updateSetting({ id, data: newData }));

    if (updateSetting.fulfilled.match(resultAction)) {
      message.success('Settings updated successfully');
    }
  }

  return (
    <>
      <Card className='v-mb-20'>
        <h4 className='v-content-title'>Account settings</h4>

        <div className='v-settings'>
          <Account
            onFinish={onFinish}
            params={params}
          />
        </div>
      </Card>

      <Card className='v-mb-20'>
        <h4 className='v-content-title'>Purchase settings</h4>

        <div className='v-settings'>
          <Purchase
            onFinish={onFinish}
            params={params}
          />
        </div>
      </Card>

      <Card className='v-mb-20'>
        <h4 className='v-content-title'>Content settings</h4>

        <div className='v-settings'>
          <Content
            onFinish={onFinish}
            params={params}
            target={setting?.target_type}
          />
        </div>
      </Card>

      <Card className='v-mb-20'>
        <h4 className='v-content-title'>Community settings</h4>

        <div className='v-settings'>
          <Community
            onFinish={onFinish}
            params={params}
          />
        </div>
      </Card>

      <Card className='v-mb-20'>
        <h4 className='v-content-title'>Remove Ads cost</h4>

        <div className='v-settings'>
          <RemoveAds
            onFinish={onFinish}
            params={params}
          />
        </div>
      </Card>

      <Card className='v-mb-20'>
        <h4 className='v-content-title'>Rewards</h4>

        <div className='v-settings'>
          <Rewards
            onFinish={onFinish}
            params={params}
          />
        </div>
      </Card>
    </>
  );
}

export default _Settings;
